import { OnboardingGuide } from "@prismicio/editor-fields"
import { ActionListItem } from "@prismicio/editor-ui"
import type { ReactNode } from "react"

import { useOnboarding } from "../../app/services/onboarding"
import { trackSharedOnboardingGuide } from "../../app/services/tracking"

interface DocumentListSharedOnboardingProps {
  fallback?: ReactNode
}

export function DocumentListSharedOnboarding(
  props: DocumentListSharedOnboardingProps
) {
  const { fallback } = props
  const { onboarding, toggleStep, toggleGuide } = useOnboarding()

  if (onboarding.isDismissed) {
    return (
      <ActionListItem
        textVariant="normal"
        backgroundColor="transparent"
        startIcon="notStarted"
        onClick={toggleGuide}
      >
        Get started
      </ActionListItem>
    )
  }

  return (
    <OnboardingGuide
      tracking={{ track: trackSharedOnboardingGuide, source: "PageBuilder" }}
      onboardingState={onboarding}
      onToggleGuide={toggleGuide}
      onToggleStep={toggleStep}
      fallback={fallback}
    />
  )
}
